import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { TD_SESSION_ENTRY_KEY } from './SessionEntryCapture'

/**
 * If the session started on home (/) but the user navigates to any other route in the SPA,
 * we mark that so the newsletter modal does not appear when they later return to /.
 */
function ModalRouteTrace() {
    const pathname = useLocation().pathname

    useEffect(() => {
        try {
            const raw = sessionStorage.getItem(TD_SESSION_ENTRY_KEY) || ''
            const entryPath = raw.split('?')[0]
            if (entryPath === '/' && pathname !== '/') {
                sessionStorage.setItem('td_user_left_home_in_spa', '1')
            }
        } catch {
            /* ignore */
        }
    }, [pathname])

    return null
}

export default ModalRouteTrace
